import React from "react";
import "./ExternalUserRegistration.scss";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { MotifButton, MotifProgressLoader } from "@ey-xd/motif-react";
import { apiQueryWithToken } from "../../common/services/apiBaseUrlConfig";
import logger from "../../common/utils/logger";

export const ExternalUserRegistration = () => {
  const [inputValue, setInputValue] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [isVisible, setIsVisible] = React.useState(false);
  const [messageColor, setMessageColor] = React.useState("Red");
  const messageStyle = { color: messageColor };
  const [isLoading, setIsLoading] = React.useState(false);
  const validateEmail = (email) => {
    // custom email regex
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || email.length === 0) {
      return "Email is required";
    }

    if (!regex.test(email)) {
      return "Invalid email format";
    }

    // other custom validations...

    return null;
  };
  const handleChange = (e) => {
    setInputValue(e.target.value);
  };
  const registrationUrl = "api/ExternalUser/register";

  const hanldeRegistrationClick = (e) => {
    logger.info("Email", inputValue);
    var value = validateEmail(inputValue);
    if (value !== null) {
      setErrorMessage(value);
      setIsVisible(true);
    } else {
      setIsLoading(true);
      apiQueryWithToken
        .post(registrationUrl, {
          email: inputValue,
        })
        .then((response) => {
          setIsLoading(false);
          logger.info(response.data);
          setIsVisible(true);
          setMessageColor("Green");
          setErrorMessage(response.data.message);
          setInputValue("");
        })
        .catch((error) => {
          logger.error(error);
        });
    }
  };
  const args = {
    label: "Email address",
    ariaLabel: "Email address",
  };
  return (
    <div className="eureg">
      <div className="eureg-center">
        <div className="eureg-center-reg">
          <div className="eureg-center-logo-wrapper">
            <div>
              {" "}
              <img
                src={require("../../../src/common/images/EY-reg.png")}
                alt="logo"
              />
            </div>
          </div>
          <div className="eureg-form-title">Data Bureau </div>
          {isLoading ? (
            <MotifProgressLoader show variant="default" />
          ) : (
            isVisible && (
              <div className="eureg-form-message" style={messageStyle}>
                {errorMessage}
              </div>
            )
          )}
          <TextField
            className="emailTextField"
            size="small"
            variant="outlined"
            value={inputValue}
            placeholder="Enter Email"
            onChange={(e) => {
              setIsVisible(false);
              setInputValue(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <div className="eureg-button-wrapper">
            <MotifButton
              value="Submit"
              onClick={hanldeRegistrationClick}
              variant="primary"
              size="medium"
              type="submit"
              className="eureg-submit"
            >
              <span className="eureg-submit-text">Submit</span>
            </MotifButton>
          </div>
        </div>
      </div>
    </div>
  );
};
